import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../../features/passport/formatCurrency';
import * as Styled from './AmountButton.styled';
import { AmountPlaceholder } from './AmountPlaceholder';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const AmountButton = _ref => {
  let {
    showAmountPlaceholder,
    dataId,
    activeInput,
    currencyCode,
    frequency,
    isOneBigButton,
    presetAmount,
    presetName,
    doFadeIn,
    campaignLocale,
    handleClick
  } = _ref;
  const {
    t
  } = useTranslation('blocks.donation');
  const amount = formatCurrency({
    currencyCode,
    amount: presetAmount,
    locale: campaignLocale,
    options: {
      trailingZeroDisplay: 'stripIfInteger'
    }
  });
  return /*#__PURE__*/_jsx(Styled.AmountButton, {
    className: "donation-amount-button",
    "data-id": dataId,
    "data-amount": presetAmount,
    type: "button",
    "aria-current": activeInput === presetName ? 'true' : 'false',
    isActive: activeInput === presetName,
    isOneBigButton: isOneBigButton,
    doFadeIn: doFadeIn,
    onClick: e => {
      e.preventDefault();
      handleClick();
    },
    children: showAmountPlaceholder ? /*#__PURE__*/_jsx(AmountPlaceholder, {
      currencyCode,
      locale: campaignLocale
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [!isOneBigButton && /*#__PURE__*/_jsx(_Fragment, {
        children: amount
      }), isOneBigButton && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          children: t('AmountButton.frequencyDonation', {
            frequency,
            defaultValue: `${frequency} donation`
          })
        }), /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsxs("span", {
            children: [amount, "\xA0"]
          }), /*#__PURE__*/_jsx("span", {
            children: currencyCode
          })]
        })]
      })]
    })
  });
};